import{__assign as o}from'../../dependencies/tslib/tslib.es6.js';var t={duration:{short:.1,standard:.3}},r=function(r){t=o(o({},t),r)};export{r as initializeTransitions,t as transitions};
